import { OPEN_ORDER_STATUSES } from '../../constants/order'
import { EndpointQueryParameters } from '../../types/strapi/strapi'

export function buildOpenOrdersQuery(clientDocumentId: string): EndpointQueryParameters {
    return {
        filters: {
            client: { documentId: { $eq: clientDocumentId } },
            orderStatus: { $in: OPEN_ORDER_STATUSES },
        },
        sort: ['id:desc'],
        pagination: { page: 1, pageSize: 50 },
        fields: ['documentId', 'id', 'orderStatus'],
        populate: {
            client: {
                fields: ['documentId', 'name'],
            },
        },
    }
}
